import moment from 'moment'

export const getWorkingDaysBetweenDates = (startDate, endDate) => {
	if (moment(startDate).isAfter(endDate)) {
		return -1
	}

	let currentDate = moment(startDate).add(1, 'day')
	let workingDays = 0

	while (currentDate.isBefore(endDate)) {
		if (currentDate.day() !== 0 && currentDate.day() !== 6) {
			workingDays++
		}
		currentDate.add(1, 'day')
	}

	return workingDays
}
